import React, { useEffect } from 'react';
import { SurveyQuestion } from '../../redux/types/survey';
import SurveyQuestionsComponent from '../../components/SurveyQuestionsComponent';

const defaultQuestions = [
  {
    text: 'Do you currently Own, Rent, Live with family or other?',
    type: 2,
    choices: ['Own', 'Rent', 'Live /w Fam', 'Other'],
  },
  {
    text: 'Do you have a buyers/leasing agent?',
    type: 3,
    choices: ['Yes', 'No'],
  },
  {
    text: 'How long until you buy/rent a home?',
    type: 2,
    choices: ['Now', '1-3 Month', '3-6 Month', 'Not sure'],
  },
];

type Props = {
  loadSurveyQuestions: () => void;
  updateQuestions: (questions: SurveyQuestion[]) => void;
  surveyQuestions: SurveyQuestion[];
  loading: boolean;
  updating: boolean;
  builderId: number;
};

const SurveyQuestions: React.FC<Props> = (props) => {
  const {
    loadSurveyQuestions,
    updateQuestions,
    surveyQuestions,
    loading,
    updating,
    builderId,
  } = props;

  useEffect(() => {
    if (builderId < 0) {
      return;
    }
    loadSurveyQuestions();
  }, [builderId, loadSurveyQuestions]);

  return (
    <SurveyQuestionsComponent
      loadSurveyQuestions={loadSurveyQuestions}
      updateQuestions={updateQuestions}
      surveyQuestions={surveyQuestions}
      loading={loading}
      updating={updating}
      defaultQuestions={defaultQuestions}
      variant="preTour"
    />
  );
};

export default React.memo(SurveyQuestions);
